import { PolluxGridConfig } from "../../../../../components/common/pollux-grid-config/pollux-grid-config";

export const valuationsGridColumns: PolluxGridConfig[] = [
  {
    field: "checkbox",
    type: "checkbox",
    width: 40
  },
  {
    title: "valuation.Region",
    field: "Region",
    width: 100
  },
  {
    title: "valuation.Sector",
    field: "Sector",
    width: 100
  },
  {
    title: "valuation.PrimaryUse",
    field: "PrimaryUse",
    width: 100
  },
  {
    title: "valuation.PercentEquity",
    field: "PercentEquity",
    type: "percentage",
    width: 150
  },
  {
    title: "valuation.TenureType",
    field: "TenureType",
    width: 100
  },
  {
    title: "valuation.PropFileRefNo",
    field: "PropFileRefNo",
    width: 100
  },
  {
    title: "valuation.EntityId",
    field: "EntityId",
    width: 100
  },
  {
    title: "valuation.PreparerName",
    field: "PreparerName",
    width: 100
  },
  {
    title: "valuation.PropertyIrr",
    field: "PropertyIrr",
    type: "percentage",
    width: 150
  },
  {
    title: "valuation.TotalArea",
    field: "TotalArea",
    type: "area",
    width: 150
  },
  {
    title: "valuation.GrossValue",
    field: "GrossValue",
    type: "currency",
    width: 150
  },
  {
    title: "valuation.CapitalCosts",
    field: "CapitalCosts",
    type: "currency",
    width: 150
  },
  {
    title: "valuation.AcquisitionCosts",
    field: "AcquisitionCosts",
    type: "currency",
    width: 150
  },
  {
    title: "valuation.NetValue",
    field: "NetValue",
    type: "currency",
    width: 150
  },
  {
    title: "valuation.SayValue",
    field: "SayValue",
    type: "currency",
    width: 150
  },
  {
    title: "valuation.EquivalentYield",
    field: "EquivalentYield",
    type: "percentage",
    width: 150
  },
  {
    title: "valuation.TrueEquivalentYield",
    field: "TrueEquivalentYield",
    type: "percentage",
    width: 150
  },
  {
    title: "valuation.InitialYield",
    field: "InitialYield",
    type: "percentage",
    width: 150
  },
  {
    title: "valuation.ReversionaryYield",
    field: "ReversionaryYield",
    type: "percentage",
    width: 150
  },
  {
    title: "valuation.GrossRent",
    field: "GrossRent",
    type: "currency",
    width: 150
  },
  {
    title: "valuation.GrossRentalValue",
    field: "GrossRentalValue",
    type: "currency",
    width: 150
  },
  {
    title: "valuation.NetRent",
    field: "NetRent",
    type: "currency",
    width: 150
  },
  {
    title: "valuation.NoOfTenants",
    field: "NoOfTenants",
    type: "number",
    width: 150
  },
  {
    title: "valuation.CurrencyCode",
    field: "CurrencyCode",
    width: 100
  },
  {
    title: "valuation.CurrencyDescription",
    field: "CurrencyDescription",
    width: 100,
  },
  {
    title: "valuation.reportId",
    field: "reportID",
    width: 100
  },
  {
    title: "valuation.valuationPortfolioName",
    field: "valuationPortfolioDescription",
    width: 300
  },
  {
    title: "valuation.scenario",
    field: "scenario",
    width: 200
  },
  {
    title: "valuation.importedAt",
    field: "importDate",
    type: "datetime",
    width: 200
  },
  {
    title: "valuation.importedBy",
    field: "importByUserDescription",
    width: 200
  }
];
